import { render, staticRenderFns } from "./config.vue?vue&type=template&id=e8c7d112"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8c7d112')) {
      api.createRecord('e8c7d112', component.options)
    } else {
      api.reload('e8c7d112', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=e8c7d112", function () {
      api.rerender('e8c7d112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/5-1-nav-bar-1/config.vue"
export default component.exports